import {API_SERVERLESS, getFetch} from '~commonApi';

export function apiCommunicationCentreModalClientMessageHistory(correlationId: number) {
    return getFetch(`${API_SERVERLESS}/communicationCentreModalClient/v4/CCMCH/messageHistory/${correlationId}`, true);
}
